import { Application, Sequence, Notification } from '../types';
import { FSMInstruction } from './FsmTypes';
import { ConditionInstruction } from './ConditionTypes';
import { LoopInstruction } from './LoopTypes';
import { LogInstruction } from './LogTypes';
import { OutputInstruction } from './OutputTypes';
import { WaitInstruction } from './WaitTypes';
import { TriggerInstruction } from './TriggerTypes';
import { SetVariableInstruction } from './SetVariableTypes';
import { MotorInstruction } from './motor_types';
import { RobotInstruction } from './RobotSimulateTypes';
import { RobotLoopInstruction } from './RobotLoopTypes';
import { InstructionState } from "../constants";

export enum InstructionCategory {
  MOTOR = 'motor',
  WAIT_FOR = 'waitFor',
  TRIGGER = 'trigger',
  LOOP = 'loop',
  OUTPUT = 'output',
  SET_VARIABLE = 'setVariable',
  CONDITION = 'condition',
  ROBOT = 'robot',
  ROBOT_LOOP = 'robotLoop',
  LOG = 'log',
  FSM = 'fsm',
}

export interface InstructionBase extends Notification {
  mApp: Application
  sequence: Sequence
  state: InstructionState
}

export type Instruction =
  LoopInstruction |
  LogInstruction |
  FSMInstruction |
  ConditionInstruction |
  OutputInstruction |
  WaitInstruction |
  TriggerInstruction |
  SetVariableInstruction |
  MotorInstruction |
  RobotInstruction |
  RobotLoopInstruction;
